import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class MessageSubject
{
    public type: string;
    public data?: any;

    constructor(type: string, data: any = null)
    {
        this.type = type;
        this.data = data;
    }
}

@Injectable({
    providedIn: 'root'
})
/**
 * This Service allow communication between components by sending a custom message through Service class.
 */
export class MessengerService
{
    private subject = new Subject<MessageSubject>();

    public sendMessage(message: MessageSubject): void
    {
        this.subject.next(message);
    }

    public clearMessage(): void
    {
        this.subject.next(null);
    }

    public receiveMessage(): Observable<MessageSubject>
    {
        return this.subject.asObservable();
    }
}
